import { Product } from "../types/product";

const extractCombinedTagKeysFromProduct = (product: Product): string[] => {
    const originalTags = product.tags || [];
    const tableTags = Object.values(product.tables).flatMap((table) =>
        Object.values(table.subProducts).flatMap(
            (subProduct) => subProduct.tags
        )
    );

    const combinedTagKeys = [...new Set([...originalTags, ...tableTags])];

    return combinedTagKeys;
};

export default extractCombinedTagKeysFromProduct;
